import React from 'react';
import defaultCourseImg from "../../../assets/img/course_default.png";
export let ImageModeToUse = /*#__PURE__*/function (ImageModeToUse) {
  ImageModeToUse[ImageModeToUse["PATH"] = 1] = "PATH";
  ImageModeToUse[ImageModeToUse["BASE64"] = 2] = "BASE64";
  return ImageModeToUse;
}({});
export const CardCourseHeaderComponent = props => {
  const {
    children,
    imagePath = defaultCourseImg,
    imageModeToUse = ImageModeToUse.PATH,
    imageBase64,
    mode,
    data
  } = props;
  const backgroundImageVal = React.useMemo(() => {
    switch (imageModeToUse) {
      case ImageModeToUse.PATH:
        return `url(${imagePath})`;
      case ImageModeToUse.BASE64:
        return 'url("data:image/png;base64,' + imageBase64 + '")';
    }
  }, [imageModeToUse, imagePath, imageBase64]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "card-bg cursor-pointer",
    style: {
      backgroundImage: backgroundImageVal
    }
  }), data.duration && /*#__PURE__*/React.createElement("span", {
    className: "badge badge-hours rounded-pill bg-primary text-bg-primary position-absolute untouchable"
  }, /*#__PURE__*/React.createElement("span", {
    className: "mdi mdi-clock me-2"
  }), data.duration, " horas"), mode && /*#__PURE__*/React.createElement("span", {
    className: "badge badge-status rounded-pill bg-secondary text-bg-secondary position-absolute untouchable"
  }, /*#__PURE__*/React.createElement("span", {
    className: "mdi mdi-web me-2"
  }), "Online"), children);
};